import { actions } from '@/modules/SuiviFactures/store/modules/SuiviFacturesAvantEcheance/actions';
import {
    state,
    SuiviFacturesAvantEcheanceState
} from '@/modules/SuiviFactures/store/modules/SuiviFacturesAvantEcheance/state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { mutations } from './mutations';
import { getters } from './getters';

const module: Module<SuiviFacturesAvantEcheanceState, RootState> = {
    state,
    actions,
    mutations,
    getters,
};

export default module;
export type { SuiviFacturesAvantEcheanceState };
